/// <reference path='../../../../../typings/index.d.ts' />
/// <reference path='../controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';
    import ICustomControlsModel = Meevo.Components.BaseClasses.ICustomControlsModel;
    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import FileTypes = Meevo.Model.FileTypes;
    import FileMetadata = Meevo.Model.FileMetadata;
    import ICustomDataResource = Meevo.Model.ICustomDataResource;

    interface ICustomControlsController {
        controls: Array<Meevo.Model.IUserDefinedControl>,
        locked: boolean,
        model: ICustomControlsModel,
        innerModel: any,
        controlTypeEnum: any,
        charLimit: number,
        isObjectStateActive: (objectStateEnum: ObjectStateEnum) => boolean,
        fileTypesEnum: any,
        appAreaEnum: Meevo.Model.AppAreaEnum,
        entityId: Guid | string,
        hideHeader: boolean,
        headerText: string,
        textBoxSize: number,

        init(): void
    }

    export class CustomControlsController implements ICustomControlsController {
        static $inject = [
            '$scope',
            '$translate',
            'meevo.components.modal.ModalService'
        ];

        controls: Array<Meevo.Model.IUserDefinedControl>;
        locked: boolean;
        model: ICustomControlsModel;
        innerModel: any;
        controlTypeEnum: any = Meevo.Model.ControlTypeEnum;
        fileTypesEnum: any = Meevo.Model.FileTypes;
        charLimit: number = 2000;
        appAreaEnum: Meevo.Model.AppAreaEnum;
        entityId: Guid | string;
        hideHeader: boolean;
        headerText: string;
        udfImageTemplate: boolean;
        udfImageDateUpdated: string;
        textBoxSize: number = 60;

        constructor(
            private $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            protected modalService: Meevo.Components.Modal.IModalService
        ) {}

        /**
         * Directive initialize
         * */
        public init(): void {
            this.headerText = this.headerText || this.$translate.instant("HEADER_CUSTOM_FIELDS");
            if (typeof this.model === 'undefined') { // for getting answers
                this.model = {
                    answers: []
                };
            }
            if (typeof this.innerModel === 'undefined') { // for inner purposes
                this.innerModel = {};
            }

            this.$scope.$watch(() => this.controls, (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                    this.parseControls();
                }
            });

            this.$scope.$watch(() => this.entityId, () => {
                this.prepareAnswers();
            });

            this.$scope.$watch(() => this.innerModel, () => {
                this.prepareAnswers();
            }, true);

            this.parseControls();
        }

        /**
         * Check if object state is active
         * */
        public isObjectStateActive(objectStateEnum: ObjectStateEnum): boolean {
            return objectStateEnum === ObjectStateEnum.Active;
        };

        /**
         * Parse controls, make some items preparation
         * */
        private parseControls(): void {

            this.controls.forEach((control) => {

                switch (control.controlTypeEnum) {
                    case ControlTypeEnum.DropDown:
                    case ControlTypeEnum.Radio:
                        if (control.answers.length > 0 && control.answers[0].answerItems.length > 0) { // can be only one answer, so model = first answer items ids
                            this.innerModel[control.controlName] = control.answers[0].answerItems[0].item_TId;
                        } else { // model is default item id
                            this.innerModel[control.controlName] = null;

                            control.items.forEach((item: Meevo.Model.IUserDefinedControlValue) => {
                                if (item.isDefault) {
                                    this.innerModel[control.controlName] = item.item_TId;
                                }
                            });
                        }
                        break;
                    case ControlTypeEnum.ListBox:
                        this.innerModel[control.controlName] = [];

                        if (control.answers.length > 0) { // can be list of answers, so model = array of answer items ids
                            control.answers[0].answerItems.forEach((item: Meevo.Model.IUserDefinedControlAnswerItem) => {
                                this.innerModel[control.controlName].push(item.item_TId);
                            });
                        } else { // can be list of answers, so model = array of default items ids
                            control.items.forEach((item: Meevo.Model.IUserDefinedControlValue) => {
                                if (item.isDefault) {
                                    this.innerModel[control.controlName].push(item.item_TId);
                                }
                            });
                        }

                        break;
                    case ControlTypeEnum.CheckBox:
                        this.innerModel[control.controlName] = [];

                        // model is array of boolean values - checked or not
                        control.items.forEach((item: Meevo.Model.IUserDefinedControlValue) => {
                            let value: boolean;

                            if (control.answers.length > 0) { // search item with specific id in answers list
                                let itemInAnswers = _.findWhere(control.answers[0].answerItems, {item_TId: item.item_TId});

                                value = Boolean(itemInAnswers);
                            } else { // check if value is default
                                value = item.isDefault;
                            }

                            this.innerModel[control.controlName].push(value);
                        });

                        break;
                    case ControlTypeEnum.TextArea:
                    case ControlTypeEnum.TextBox:
                    case ControlTypeEnum.Signature:
                        if (control.answers.length > 0) {
                            this.innerModel[control.controlName] = control.answers[0].displayValue;
                        } else {
                            this.innerModel[control.controlName] = '';
                        }
                        break;
                    case ControlTypeEnum.AlertingDatePicker:
                    case ControlTypeEnum.DatePicker:
                        if (control.answers.length > 0 && control.answers[0].displayValue) {
                            this.innerModel[control.controlName] = new Date(control.answers[0].displayValue);
                        } else {
                            this.innerModel[control.controlName] = undefined;
                        }
                        break;
                    case ControlTypeEnum.ImageUpload:
                        if (control.answers.length > 0 && control.answers[0].displayValue) {
                            this.innerModel[control.controlName] = control.answers[0].customDataResourceObject;
                            this.udfImageDateUpdated = control.answers[0].dateUpdated;
                        } else {
                            this.innerModel[control.controlName] = {};
                        }
                        break;
                    case ControlTypeEnum.DocumentUpload:
                        if (control.answers.length > 0 && control.answers[0].displayValue) {
                            if (control.answers[0].customDataResourceObject) {
                                this.innerModel[control.controlName] = [{
                                    ...control.answers[0].customDataResourceObject,
                                    dateUploaded: control.answers[0].dateUpdated,
                                }]
                            } else {
                                this.innerModel[control.controlName] = [...(control.answers[0].customDataResourceObjectList || [])]
                            }
                        } else {
                            this.innerModel[control.controlName] = [];
                        }
                        break;
                }
            });
        }

        /**
         * Prepare model with answers
         * */
        private prepareAnswers(): void {
            this.model.answers = [];

            this.controls.forEach((control) => {
                let model;

                switch (control.controlTypeEnum) {
                    case ControlTypeEnum.DropDown:
                    case ControlTypeEnum.Radio:
                        if (this.innerModel[control.controlName] !== null) {
                            this.prepareAnswerItems(control, [this.innerModel[control.controlName]]);
                        }
                        break;
                    case ControlTypeEnum.ListBox:
                    case ControlTypeEnum.CheckBox:
                        model = this.innerModel[control.controlName];
                        this.prepareAnswerItems(control, model);
                        //if (_.some(model)) { // if model has at least one not falsie value
                        //    this.prepareAnswerItems(control, model);
                        //}
                        break;
                    case ControlTypeEnum.TextArea:
                    case ControlTypeEnum.TextBox:
                    case ControlTypeEnum.AlertingDatePicker:
                    case ControlTypeEnum.Signature:
                        this.model.answers.push({
                            control_TId: control.control_TId,
                            displayValue: this.innerModel[control.controlName] || '',
                            appAreaEnum: this.appAreaEnum,
                            entity_Id: this.entityId
                        });
                        break;
                    case ControlTypeEnum.DatePicker:
                        this.model.answers.push({
                            control_TId: control.control_TId,
                            displayValue: this.innerModel[control.controlName] ? moment(this.innerModel[control.controlName]).format('MM/DD/YYYY') : '',
                            appAreaEnum: this.appAreaEnum,
                            entity_Id: this.entityId
                        });
                        break;
                    case ControlTypeEnum.ImageUpload:
                        model = this.innerModel[control.controlName];
                        model.resourceType = FileTypes.CustomDataImage;
                        if (Object.keys(this.innerModel[control.controlName]).length > 1) {
                            this.model.answers.push({
                                control_TId: control.control_TId,
                                displayValue: '',
                                customDataResourceObject: model,
                                appAreaEnum: this.appAreaEnum,
                                entity_Id: this.entityId
                            });
                        }
                        break;
                    case ControlTypeEnum.DocumentUpload:
                        model = this.innerModel[control.controlName];
                        this.model.answers.push({
                            control_TId: control.control_TId,
                            displayValue: '',
                            customDataResourceObjectList: this.innerModel[control.controlName],
                            appAreaEnum: this.appAreaEnum,
                            entity_Id: this.entityId
                        });
                        break;
                }
            });
        }

        /**
         * Prepare answers for controls with items
         * */
        private prepareAnswerItems(control: Meevo.Model.IUserDefinedControl, selectedItems: Array<Guid | boolean>): void {
            let answer = {
                control_TId: control.control_TId,
                displayValue: '',
                answerItems: [],
                appAreaEnum: this.appAreaEnum,
                entity_Id: this.entityId
            };
            if (!_.some(selectedItems)) {
                answer.answerItems.push({
                    control_TId: control.control_TId,
                    item_TId: '00000000-0000-0000-0000-000000000000'
                });
                this.model.answers.push(answer);
            }

            selectedItems.forEach((item: Guid | boolean, index) => {
                let selectedItem: Meevo.Model.IUserDefinedControlValue;

                if (item === true) { // checkbox control, selected item
                    selectedItem = control.items[index];
                } else if (item === false) { // checkbox control, not selected item
                    return;
                } else {
                    selectedItem = _.findWhere(control.items, {item_TId: item});
                }

                answer.answerItems.push({
                    control_TId: control.control_TId,
                    item_TId: selectedItem['item_TId']
                });
            });

            this.model.answers.push(answer);
        }

        bindCustomFile(imageData: FileMetadata
            , url: any): any {
            if (imageData) {
                url = this.searchFile(imageData,url);
            }
            return url;
        }

        /**
     * search for the storage file URL if model implements FileMetadata
     */
        searchFile(filedetails, defaultUrl): string {
            let fileUrl = defaultUrl;
            if (filedetails
                && filedetails.meevoFile
                && filedetails.meevoFile.files
                && filedetails.meevoFile.files.length > 0) {

                filedetails.meevoFile.files.forEach(function (setting) {
                    if (setting.key === "Source") {
                        fileUrl = setting.fileUrl;
                    }
                });
            }


            return fileUrl;
        }

        deleteImageUpload(control: Meevo.Model.IUserDefinedControl): void {
            const modalOptions = {
                showCancelButton: true,
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON',
                okButtonContentKey: 'LABEL_YES'
            };

            this.modalService.warning('MESSAGE_DELETE_CONFIRMATION', 0, true, modalOptions)
                .then((confirmResult: boolean) => {
                    if (confirmResult) {
                        this.innerModel[control.controlName].isStorageUpdated = true;
                        this.innerModel[control.controlName].fileGuid = null;
                        this.innerModel[control.controlName].meevoFile.files = null;
                        this.udfImageDateUpdated = null;
                        this.udfImageTemplate = false;
                    }
            });
            }

        public openImageUploadModal(control: Meevo.Model.IUserDefinedControl, isImageExist?: boolean): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/components/udf-image-upload-component/udf-image-upload.component.html',
                controller: Meevo.Components.UdfImageUpload.UdfImageUploadComponent,
                controllerAs: '$ctrl',
                bindToController: true,
                escapeToClose: false,
                preserveScope: true,
                skipHide: true,
                multiple: true,
                locals: {
                    fileType: this.fileTypesEnum.CustomDataImage,
                    meevoFile: this.innerModel[control.controlName].meevoFile,
                    fileGuid: this.innerModel[control.controlName].fileGuid,
                    isStorageUpdated: this.innerModel[control.controlName].isStorageUpdated,
                    mimeType: this.innerModel[control.controlName].contentType,
                    udfImageTemplate: this.innerModel[control.controlName].fileGuid,
                    udfImageDateUpdated: this.udfImageDateUpdated,
                    revertIcon: isImageExist,
                    ngDisabled: this.locked,
                }
            };

            this.modalService.showCustom(options)
                .then((res: ICustomDataResource) => {
                    this.udfImageDateUpdated = null;
                    this.innerModel[control.controlName] = res;
                });
        }
    }
}
